import React from "react";
import Typography from "@carrier-io/air-react/Typography";
import Box from "@carrier-io/air-react/Box";

interface CreateUserHead {
  title?: string;
  description?: string;
}

export const CreateUserHead: React.FC<CreateUserHead> = ({
  title,
  description,
}) => {
  return (
    <Box sx={{ marginBottom: 2 }}>
      <Typography
        variant="h6"
        sx={{
          marginBottom: 2,
        }}
      >
        {title}
      </Typography>
      <Typography
        paragraph
        sx={{
          marginBottom: "0",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};
